import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {Divider} from "primereact/divider";
import {Button} from "primereact/button";
import {TabPanel, TabView} from "primereact/tabview";
import {Dialog} from "primereact/dialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import AudioDialogInfo from "../AudioDialogInfo";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {setTrunkIds} from "../../../../redux/actions/actionsTrunk";
import AudioDialogManagement from "../DialogManagement";
import AudioDialogGeneralSettings from "../AudioDialogGeneralSettings";
import {setAudioDialogVisible, setAudioErrorField} from "../../../../redux/actions/actionsAudio";
import {archiveAudio, createAudio, updateAudio} from "../../../../redux/api/apiAudio";
import {validateAudioForm} from "../../../../redux/validator/validator";
import {ProgressBar} from "primereact/progressbar";
import {getItem} from "../../../../redux/cache/cacheService";
import {codes} from "../../../../redux/notificationCodes";
import {getNotificationMessage} from "../../../../redux/api/apiNotifications";
import {getUsersManagerUserBranchesData} from "../../../../redux/api/apiUsersList";
import AudioFilesComponent from "../AudioFiles";

const AudioDialog = (props: any) => {
    const dispatch = useAppDispatch()
    const audioData = useAppSelector(state => state.AudioListReducer.audioData);
    const dialogVisible = useAppSelector(state => state.AudioListReducer.audioDialogVisible);
    const createLoader = useAppSelector(state => state.AudioListReducer.createLoader);
    const archiveTableToggle = useAppSelector(state => state.AudioListReducer.archiveAudioTableToggle);
    const [activeIndex, setActiveIndex] = useState(0);
    const [showDeleteNotification, setShowDeleteNotification] = useState<boolean>(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    // @ts-ignore
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    // @ts-ignore
    const errorFields = useAppSelector(state => state.CompaniesListReducer.errorFields);
    const dialerPermissions = checkPermissions(rolesVision, 'Audio');
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const [audioSrc, setAudioSrc] = useState<any>(null);
    const audioDeleteMessage = useAppSelector(state => state.NotificationsReducer.audioDeleteMessage);
    const user = useAppSelector(state => state.UsersReducer.userData);
    const [visibleDeletedMessage, setVisibleDeletedMessage] = useState<any>(false);
    const [audios, setAudios] = useState<any[]>([]);
    const [audioFilesMap, setAudioFilesMap] = useState<{ [fileName: string]: File }>({});

    const {
        create: hasCreatePermission,
        update: hasUpdatePermission,
        delete: hasDeletePermission,
    } = dialerPermissions;

    let audio_delete_questions = getItem(codes.audio_delete_questions);

    const deletedAudioInfo = {
        audioId: audioData?.groupId
    };

    const progressBar = <ProgressBar mode="indeterminate" style={{height: '2px', maxWidth: '95%'}}></ProgressBar>;
    const audioDeleteQuestions = <div>{audioDeleteMessage ? audioDeleteMessage.text : audio_delete_questions ? audio_delete_questions : progressBar}</div>

    useEffect(() => {
        setActiveIndex(0);
    }, [dialogVisible]);

    useEffect(() => {
        setAudioSrc(null);
    }, []);

    useEffect(() => {
        if (!dialogVisible || props.skipBranchesFetch) {
            return;
        }
        dispatch(getUsersManagerUserBranchesData(jwtToken?.jwtToken));
    }, [dialogVisible, props.skipBranchesFetch, jwtToken?.jwtToken]);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {

    }, [dialogVisible]);

    useEffect(() => {
        if (audioData?.phones?.length) {
            dispatch(setTrunkIds(audioData?.phones));
        } else {
            dispatch(setTrunkIds(null));
        }
    }, [dialogVisible]);

    useEffect(() => {
        if (errorFields && errorFields?.nameUniq) {
            setActiveIndex(0);
        }
    }, [errorFields])

    const closeDialogVisible = () => {
        dispatch(setAudioDialogVisible(false));
        dispatch(setAudioErrorField(null));
    }
    const updateAudioFile = async (type: string) => {
        const formData = new FormData();

        formData.append('GroupName', audioData?.groupName || '');
        formData.append('Description', audioData?.description || '');
        formData.append('IsActive', audioData?.isActive || 'false');
        formData.append('AudioGroupId', audioData?.groupId || '');

        audioData?.audioGroupBranches?.forEach((item: { id: string | Blob }, index: number) => {
            if (item?.id == null) {
                return;
            }
            formData.append(`AudioGroupBranches[${index}].id`, item.id);
        });

        for (const audio of audios) {
            const raw = audioFilesMap[audio.name];
            if (!raw) continue;

            const fileName = audio.name.endsWith('.mp3') ? audio.name : `${audio.name}.mp3`;
            const file = raw instanceof File
                ? new File([raw], fileName, { type: 'audio/mpeg' })
                : new File([raw], fileName, { type: 'audio/mpeg' });

            formData.append('Files', file, file.name);
        }

        const audioSettings = (audioData?.audios || []).map((audio: any) => ({
            fileName: audio.audioFileName || audio.audioName,
            isActive: !!audio.isActive
        }));

        formData.append('AudioSettings', JSON.stringify(audioSettings));

        setAudios([]);
        setAudioFilesMap({});

        const validationErrors = validateAudioForm(audioData);

        if (!validationErrors) {
            dispatch(updateAudio(formData, jwtToken?.jwtToken));
            setAudioSrc(null);
            if (type === 'with_close') {
                closeDialogVisible();
            }
        } else {
            dispatch(setAudioErrorField(validationErrors));
            if (
                validationErrors.groupName ||
                validationErrors?.description ||
                validationErrors?.branchId
            ) {
                setActiveIndex(0);
            }
            else if (validationErrors.audioFileName) {
                setActiveIndex(1);
            }
        }
    };


    const createAudioFile = (type: string) => {
        const formData = new FormData();

        formData.append('GroupName', audioData?.groupName || '');
        formData.append('Description', audioData?.description || '');
        formData.append('AudioId', audioData?.groupId || '');

        audioData?.audioGroupBranches?.forEach((item: { id: string | Blob }, index: number) => {
            if (item?.id == null) {
                return;
            }
            formData.append(`AudioGroupBranches[${index}].id`, item.id);
        });

        audios?.forEach((audio: any) => {
            const file = audioFilesMap[audio.name];
            if (file) {
                formData.append('Files', file, file.name);
            }
        });

        const audioSettings = (audioData?.audios || []).map((audio: any) => ({
            fileName: audio.audioFileName || audio.audioName,
            isActive: !!audio.isActive
        }));

        formData.append('AudioSettings', JSON.stringify(audioSettings));

        const validationErrors = validateAudioForm(audioData);

        if (!validationErrors) {
            dispatch(createAudio(formData, jwtToken?.jwtToken));
            setAudioSrc(null);
            setAudios([]);
            setAudioFilesMap({});
            if (type === 'with_close') {
                closeDialogVisible();
            }
        } else {
            dispatch(setAudioErrorField(validationErrors));
            if (validationErrors.groupName || validationErrors?.description || validationErrors?.branchId) {
                setActiveIndex(0);
            }
            else if (validationErrors.audioFileName) {
                setActiveIndex(1);
            }
        }
    };


    let audioDeletedMessage = getItem(codes.audio_delete_questions);
    const showDeletionNotification = () => {
        if (!audioDeletedMessage && !audioDeleteMessage) {
            dispatch(getNotificationMessage(user?.userId, 219, user));
        }
        setShowDeleteNotification(true);
    }

    const showSaveChangesNotification = () => {
        dispatch(setAudioDialogVisible(false));
    }

    const setActiveTabIndex = (e: any) => {
        setActiveIndex(e.index);
    }

    const footer = (
        <div className="dialog-footer">
            <Divider/>
            <div className="buttons">
                {hasDeletePermission && audioData?.groupId && <Button icon={windowWidth > 1248 ? "pi pi-trash" : ''}
                                                                       className="p-button-outlined"
                                                                       label="Видалити"
                                                                       onClick={showDeletionNotification}
                />}
                <Button icon={windowWidth > 1248 ? "pi pi-ban" : ''}
                        className="p-button-outlined"
                        label="Відміна"
                        loading={createLoader}
                        onClick={() => {
                            showSaveChangesNotification()
                        }}
                />
                {hasCreatePermission && !audioData?.groupId && <Button icon={windowWidth > 1248 ? "pi pi-save" : ''}
                                                                             className=""
                                                                             label="Створити та зберегти"
                                                                             loading={createLoader}
                                                                             onClick={() => {
                                                                                 createAudioFile('')
                                                                             }}
                />}
                {hasUpdatePermission && audioData?.groupId && <Button icon={windowWidth > 1248 ? "pi pi-save" : ''}
                                                                            label="Зберегти"
                                                                            loading={createLoader}
                                                                            onClick={() => {
                                                                                updateAudioFile('')
                                                                            }}
                />}
            </div>
        </div>
    );

    return (
        <Dialog
            header="Налаштування групи"
            footer={archiveTableToggle ? footer : ''}
            visible={dialogVisible}
            dismissableMask={false}
            closeOnEscape={false}
            draggable={true}
            blockScroll={true}
            position="top"
            className='dialogInfo'
            style={{width: '65vw', maxWidth: "1200px", minHeight: "80vh", zIndex: '1101px !important'}}
            onHide={() => showSaveChangesNotification()}
        >
            {audioData && <div className="company-info-popup">
                <AudioDialogInfo/>
                <Divider style={{margin: '0 0 20px 0'}}/>
                {audioData?.groupId &&
                    <>
                        <AudioDialogManagement/>
                        <Divider style={{margin: '0 0 20px 0'}}/>
                    </>
                }
                <TabView className="user-dialog-info" activeIndex={activeIndex} onTabChange={(e) => setActiveTabIndex(e)}>
                    <TabPanel header="Загальні налаштування">
                        {audioData && <AudioDialogGeneralSettings audioSrc={audioSrc} setAudioSrc={setAudioSrc}/>}
                    </TabPanel>
                    <TabPanel header="Аудіо файли">
                        <AudioFilesComponent
                            audios={audios}
                            setAudios={setAudios}
                            audioFilesMap={audioFilesMap}
                            setAudioFilesMap={setAudioFilesMap}
                        />
                    </TabPanel>
                </TabView>
            </div>}
            <ConfirmDialog visible={showDeleteNotification} onHide={() => setShowDeleteNotification(false)} message={audioDeleteQuestions}
                           icon="pi pi-exclamation-triangle" acceptLabel="Продовжити" rejectLabel="Відмінити" accept={() => {
                dispatch(archiveAudio(deletedAudioInfo.audioId, jwtToken?.jwtToken));
                if (deletedAudioInfo.audioId === props.selectedRowData) {
                    props.setSelectedRowData(null);
                }
                props.setSelectedRowData(null);
                dispatch(setAudioDialogVisible(false));
            }
            }/>
        </Dialog>
    )
}

export default AudioDialog
